import styled, { css } from "styled-components";

export const StyledExapansionPanel = styled.div`
    overflow: hidden;

    ${({ unexpandable }) => unexpandable && css`
        ${StyledPanelTitle} {
            cursor: initial;
        }
        ${StyledContentExapnded} {
            display: block;
        }
    `}

    ${({ expanded }) =>
        expanded && css`
            ${StyledContentExapnded} {
                display: block;
            }
        `}
`;
export const StyledPanelTitle = styled.div`
    font-size: 14px;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;
    cursor: pointer;
`;
export const StyledContentExapnded = styled.div`
    display: none;
    padding: 15px 0;
`;
